import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpEditProjectDetails, HttpEditProjectDetailsOptions} from '../http/projects.http'
import {MUTATION_KEYS} from '@/queryClient'
import {AxiosError} from 'axios'
import {ErrorResponseData} from '@/types'

interface UseEditProjectDetailsOptions {
    urlParams: {
        projectId: string
    }
    options?: UseMutationOptions<unknown, AxiosError<ErrorResponseData>, HttpEditProjectDetailsOptions['payload']>
}

export const useEditProjectDetails = ({urlParams, options}: UseEditProjectDetailsOptions) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.EDIT_PROJECT_DETAILS, urlParams.projectId],
        mutationFn: payload => httpEditProjectDetails({urlParams, payload})
    })
}
